export default [
  "assaults",
  "talks to",
  "attempts to calm",
  "feels",
  "aches for",
];

export const transitiveVerbsPlural = [
  "assault",
  "think about",
  "hold",
  "chat with",
  "mumble about",
  "fish with",
  "stalk",
  "talk to",
  "attempt to duel",
  "start a fight with",
  "conspire with",
];
export const transitiveVerbsSingle = [
  "assaults",
  "thinks about",
  "holds",
  "chats with",
  "mumbles about",
  "fishes with",
  "stalks",
  "talks to",
  "attempts to duel",
  "starts a fight with",
  "conspires with",
];
export const intransitiveVerbs = [
  "babbles $ADVERB",
  "murmurs $ADVERB",
  "paces $ADVERB",
  "gives a speech",
  "hums a $SONG",
];
export const auxiliaryVerbs = [];
export const noActionVerbs = [];
export const linkingVerbs = ["feels", "looks like", "seems to be"];
